import { Entity, formatTicker, ThemeExposure } from '@toggle/toggle';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { NonLinearStepper } from '~/components/non-linear-stepper/NonLinearStepper';

import * as S from './StepperSection.styles';

interface StepperSectionProps {
  entity?: Entity;
  theme: ThemeExposure;
  title?: string;
  description?: string;
  activeIndex: number;
  rightHeaderNode?: ReactNode;
}

export const StepperSection = ({
  entity,
  theme,
  title,
  activeIndex,
  description,
  rightHeaderNode,
}: StepperSectionProps) => {
  const { t } = useTranslation(['widget']);
  return (
    <S.SectionRow data-testid="stepper-section">
      <S.HeaderWrapper>
        {title && <S.TitleMedium>{title}</S.TitleMedium>}
        {rightHeaderNode}
      </S.HeaderWrapper>
      {entity && (
        <S.StepperWrapper>
          <NonLinearStepper
            steps={[
              {
                logoUrl: entity.logo_urls.light_png,
                hoverLabel: formatTicker(entity),
                connectorLabel: t(
                  'widget:assetOverview.knowledgeGraph.exposedTo'
                ),
              },
              {
                logoUrl: theme.theme.logo_url,
                hoverLabel: theme.theme.name,
                connectorLabel: t(
                  'widget:assetOverview.knowledgeGraph.memberOf'
                ),
                iconColor: 'var(--kg-theme)',
              },
              {
                logoUrl: theme.theme.parent.logo_url,
                hoverLabel: theme.theme.parent.name,
                iconColor: 'var(--kg-parent)',
              },
            ]}
            activeIndex={activeIndex}
            iconSize={23}
          />
        </S.StepperWrapper>
      )}
      {description && <S.BodySmall>{description}</S.BodySmall>}
    </S.SectionRow>
  );
};
